import { useCallback } from 'react';
import { useEventLobbiesRoom } from './use-event-lobbies-room.hook';

/**
 * Keeps a list of events in sync with real-time `{ event }` broadcasts on the
 * event-lobbies socket room (e.g. scheduled status changes upcoming -> active).
 * Merges the incoming event into the matching list item by id; does not add new rows.
 */
export function useEventListRealtimeSync({
	socket,
	setEvents,
}: {
	socket: any;
	setEvents: (updater: (prev: any[]) => any[]) => void;
}) {
	const handler = useCallback(
		(data: any) => {
			const incoming = data?.event;
			if (!incoming?.id) return;

			setEvents((prev) =>
				prev.some((e) => e.id === incoming.id)
					? prev.map((e) => (e.id === incoming.id ? { ...e, ...incoming } : e))
					: prev
			);
		},
		[setEvents]
	);

	useEventLobbiesRoom({ socket, handler });
}
